import { Box, Modal, Typography } from "@mui/material";
import ButtonComponent from "components/button/ButtonComponent";
import Notify from "config/notify";
import { useEffect, useState } from "react";
import { NotificationState } from "type";

const getActionsStyle = (position: NotificationState["actionsPosition"]) => ({
  ...(position === "start" && { textAlign: "left" }),
  ...(position === "end" && { textAlign: "right" }),
  ...(position === "center" && { textAlign: "center" }),
  width: "100%",
  marginTop: "-1rem",
});

/**
 * the global notification modal
 */
export default function NotificationModal() {
  const [notification, setNotification] = useState<NotificationState>({
    show: false,
    title: "",
    message: "",
    titleColor: "",
    messageColor: "",
    messageWhiteSpace: "",
    actionsPosition: "end",
    confirmLabel: "閉じる",
  });

  useEffect(() => {
    Notify.setNotification = setNotification;
  }, []);

  const handleClose = () => {
    setNotification({ show: false, title: "", message: "" });
    Notify.onClose?.();
  };

  return (
    <Modal
      open={notification.show}
      onClose={handleClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          px: 6,
          py: 4,
          backgroundColor: "var(--white)",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "400px",
        }}
      >
        {notification.title ? (
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: "bold",
              color: notification.titleColor || "var(--gray-700)",
            }}
          >
            {notification.title}
          </Typography>
        ) : null}
        {notification.message ? (
          <Typography sx={{ whiteSpace: notification.messageWhiteSpace || 'inherit', color: notification.messageColor || "var(--gray-700)", mt: 1 }}>
            {notification.message}
          </Typography>
        ) : null}
        <div
          style={getActionsStyle(notification.actionsPosition || "center") as React.CSSProperties}
        >
          <ButtonComponent
            label={notification.confirmLabel || "閉じる"}
            onClick={handleClose}
            sx={{ mt: 4, width: "auto", px: 2, mx: 0 }}
          />
        </div>
      </Box>
    </Modal>
  );
}
